'use strict';

var intentionToAssetColor = require('../../../../../../../../_virtual/intentionToAssetColor.cjs');
var assetColors = require('../types/base/ds5/assetColors.cjs');

var hasRequiredIntentionToAssetColor;

function requireIntentionToAssetColor () {
	if (hasRequiredIntentionToAssetColor) return intentionToAssetColor.__exports;
	hasRequiredIntentionToAssetColor = 1;

	var assetColors$1 = assetColors.__require();

	/**
	 * Convert the intention to the asset color
	 */ const intentionToAssetColor$1 = (intent)=>{
	    switch(intent){
	        case "success":
	            return assetColors$1.ASSET_COLORS.green;
	        case "info":
	            return assetColors$1.ASSET_COLORS.blue;
	        case "critical":
	            return assetColors$1.ASSET_COLORS.red;
	        case "warning":
	            return assetColors$1.ASSET_COLORS.orange;
	        case "recur":
	            return assetColors$1.ASSET_COLORS.purple;
	        case "discovery":
	            return assetColors$1.ASSET_COLORS.sand;
	        case "neutral":
	        default:
	            return assetColors$1.ASSET_COLORS.grey;
	    }
	};

	intentionToAssetColor.__exports.intentionToAssetColor = intentionToAssetColor$1;
	
	return intentionToAssetColor.__exports;
}

exports.__require = requireIntentionToAssetColor;
//# sourceMappingURL=intentionToAssetColor.cjs.map
